import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectEvent, TabPosition } from '@progress/kendo-angular-layout';
import { Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { RelationAccount } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { FundingSourceDto } from '~/models/modules/Asset/fundingSource';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GDataService } from '~/services/GDataService';
import { AccountsService } from '~/services/administration.ts/accounts';
import { FundingSourceService } from '~/services/modules/assets/fundingSource';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { NoteComponent } from '~/shared/components/note/note.component';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'app-upsert',
    templateUrl: './upsert.component.html',
    styleUrls: ['./upsert.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FundingSourceUpsertComponent extends MultiSiteAwareComponent implements OnInit {
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;

  _theme: string;
  _dialogComponentName: string;
  _dialogModel: any;
  _currentUser: UserSummary;
  _isLiveEnterprise: boolean;

  _model: FundingSourceDto;
  _active: boolean;
  _isDialiog: boolean;
  _pageState: PageState;
  _page = 'fundingsource';
  _entity = 'Asset';
  _language = 'en';
  _permissionScope = 'fundingsource';

  okCloseSubscription: any = null;
  _gridFieldAuth: GridFieldAuthorization[];
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _isAddTabFormValue: boolean = false;

  _deactivatedFieldsGridData: Array<any> = [];
  _dataTabsSelected: Array<any> = [];

  _gridFieldText: GridFieldTextSummary[];

  _form: FormGroup;
  _selectedLabelObjectCode: any;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isMandatory: boolean = false;

  fundingSourceId: string;
  description: string;

  // _kendoTabStripPosition: TabPosition = 'left';
  _dataTabs: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  // _customFields: CustomFieldSummary[][] = [];
  _selectedAccountIds: any[] = [];
  _invalidSubmit: boolean;
  _customFieldsValue: any;
  _selectedLabelId: number;
  _selectedTabId: number;
  _custominvalidForm: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _customTabs: any;

  _isEditForms: boolean = false;

  reactivate: boolean = false;
  reactivateItem: any;
  _selectableDataTabs: Array<any> = [];
  _allDataTabs: Array<any> = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _isOs: boolean;
  _kendoTabStripPosition: TabPosition = 'left';
  // #region Enterprise Data
  _addClassActive: boolean = false;
  _selectedAccounts: any[] = [];
  declare _tabEnabled: boolean;
  // #endregion
  @ViewChild('note') note: NoteComponent;
  @ViewChild('kendo_tabstrip_wrapper') screenTabs: ElementRef;
  constructor(
    private _fb: FormBuilder,
    private _fundingSourceService: FundingSourceService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutManager: LayoutManagerService,
    private _dataService: GDataService,
    private _layoutComponent: LayoutComponent,
    private _accountsService: AccountsService) { super(); }

  ngOnInit(): void {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    };
    this.LoadData();
  }

  async LoadData() {
    this._currentUser = this._securityService.currentUser;
    this._getdata();
    this.getAuth();
    await this.loadLabels();
    await this.fillForm();
  }
  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    if (this._pageState === PageState.ADD && this._model && this._model.id > 0) {
      this._model.id = null;
      this._model.fundingSourceId = null;
    }

    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.fundingSourceAccounts ?? []).map(
        (x: any) => +(x.account?.id ?? x.accountId ?? x.id ?? x)
      );
      this._selectedAccountIds = [...this._selectedAccounts];
    }
  }
  getAuth() {
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }
  async loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
      })
  }
  async fillForm() {
    if ((this._model && this._model.id > 0) || (this._pageState == PageState.ADD && this._model && this._model.description)) {
      this.fundingSourceId = this._model.fundingSourceId;
      this.description = this._model.description;
    }
  }
  _initForm(): void {
    this._form = this._fb.group({
      fundingSourceId: [this._model.fundingSourceId, Validators.required],
      description: [this._model.description, this.getLabel('LBL_FundingSourceDescription')?.isRequired ? Validators.required : null]
    });
  }
  getLabel(objectCode: string): GridFieldTextSummary {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;
      return result ? result : null;
    }
  }
  // #region Popup window Events
  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._active = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState }
  }
  _onCancel() {
    this._closeForm();
  }
  _closeForm(model?: any) {
    var closeComponent = {
      component: this._page,
      isClosed: true,
      response: model
    }
    this._isDialiog = false;
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects(this._page);
    //this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }
  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add("fullWidthFormForm");
    }
  }
  _edit(): void {
    this._pageState = PageState.EDIT;
  }
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  // #endregion

  _onSave(e: string) {
    this.submit(e);
  }
  _onTabSelect(e: SelectEvent): void {
    this._mobileMenuToggle();
  }
  _mobileMenuToggle() {
    let mobiletabstrip = this.screenTabs.nativeElement.querySelector('ul');
    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }
  private submit = (e: string) => {
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });
        return false;
      }
    }
    if (!this.fundingSourceId || this.fundingSourceId.length == 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: `Please fill the ${this.getLabel('LBL_FundingSourceId')?.currentText}`,
        withoutConfirm: true
      });
      return false;
    }
    else {

      if (this._customFieldsValue) {
        const entries = Object.entries(this._customFieldsValue);
        for (const [index, [key, value]] of entries.entries()) {
          this._customFieldsDictionary[key] = `${value}`;
        }
      }

      var fundingSourceRequest: any = {
        fundingSourceId: this.fundingSourceId,
        description: this.description,
        customFieldsValue: this._customFieldsDictionary,
        accountIds: this._selectedAccounts.map((c: any) => (c?.accountId != null ? +c.accountId : +c))
      }
      if (!this._model || !this._model.id) {
        this._fundingSourceService
          .createFundingSource(fundingSourceRequest)

          .subscribe((response: any) => {

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                if (!this._currentUser.isEnterprise) {
                  this.note.createNote(response.responseId);
                }
                this._fundingSourceService.fundingSourceAdded.emit(response['extraData'].data)
                if (e === "saveAndClose") {
                  this._closeForm(fundingSourceRequest);
                }
                else if (e === "saveAndCopy") {
                  this.fundingSourceId = null;
                  this._model.id = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === "saveAndNew") {
                  this.fundingSourceId = null;
                  this.description = null;
                  this._model.id = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === "save") {
                  this._pageState = PageState.EDIT;
                  if (response.responseId)
                    this._model.id = response.responseId;
                  this._model = { ...response.extraData.data };
                }
              }
              else {
                return;
              }
            }

          }
            /*  ,
             (error: any) => {
                 this._layoutComponent.openPopup({
                     title: 'Error',
                     message: 'Cannot create a funding source with existing funding source Id',
                     withoutConfirm: true
                   });
                 return false;
             } */
          );
      }
      else {
        this._fundingSourceService
          .updateFundingSource(this._model.id, fundingSourceRequest)

          .subscribe((response: any) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                if (e === "saveAndClose") {
                  this._closeForm(fundingSourceRequest);
                }
                else if (e === "saveAndCopy") {
                  this.fundingSourceId = null;
                  this._model.id = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === "saveAndNew") {
                  this.fundingSourceId = null;
                  this.description = null;
                  this._model.id = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                  this._model = { ...response.extraData.data };
                }
              }
              else {
                return;
              }
            }

          }
            /* ,
            (error: any) => {
                this._layoutComponent.openPopup({
                    title: 'Error',
                    message: 'Cannot update a funding source with existing funding source Id',
                    withoutConfirm: true
                  });
                return false;
            } */
          );
      }

    }

  }
  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }
  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };
}
